import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export const PrivateLoginRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  return isAuthenticated ? <Navigate to="/dashboard" /> : children;
};

export const PrivateDashboardRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  
  return isAuthenticated ? <Navigate to="/dashboard" /> : children;
}

// export const PrivateTeacherRoute = ({ children }) => {
//   const { isAuthenticated, user } = useAuthStore();
  
//   return isAuthenticated && user.role === 'teacher' ? children : <Navigate to="NotFound" />;
// }

export const PrivateTeacherRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuthStore();

  // Wait until auth is resolved
  if (user === null || user === undefined) {
    return null; // or return a loading spinner
  }

  if (isAuthenticated && user.role === 'teacher') {
    return children;
  }

  return <Navigate to="/NotFound" replace />;
};
